var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"type":"number"},model:{value:(_vm.selectModel),callback:function ($$v) {_vm.selectModel=$$v},expression:"selectModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }